import { render } from "./DriverWork.vue?vue&type=template&id=35aa8662&scoped=true"
import script from "./DriverWork.vue?vue&type=script&lang=js"
export * from "./DriverWork.vue?vue&type=script&lang=js"

import "./DriverWork.vue?vue&type=style&index=0&id=35aa8662&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35aa8662"]])

export default __exports__